import type { GetMenuItemsSelectedKeysProps, MenuItems } from "./menu.type";

import { uniq } from "@/utilities/array";

export const getMenuItemsKeys = (menuItems: MenuItems) => {
  if (!menuItems?.length) return [];

  const menuItemsKeys: string[] = [];

  menuItems.forEach((menuItem) => {
    if (!menuItem) return;

    const key = "key" in menuItem ? menuItem.key : undefined;

    if (key) menuItemsKeys.push(`${key}`);

    const children = "children" in menuItem ? menuItem.children : undefined;

    if (children?.length) {
      const childrenKeys = getMenuItemsKeys(children);
      menuItemsKeys.push(...childrenKeys);
    }
  });

  return uniq(menuItemsKeys.filter((menuItem) => Boolean(menuItem)));
};

export const getMenuItemsSelectedKeys = ({
  menuItems,
  pathname,
  search,
}: GetMenuItemsSelectedKeysProps) => {
  if (!menuItems?.length || !pathname) return [];

  // If pathname is home path, just return it
  if (pathname === "/") return ["/"];

  const menuItemsKeys = getMenuItemsKeys(menuItems);

  const selectedKeys = menuItemsKeys.filter(
    (menuItemKey) =>
      (pathname.startsWith(menuItemKey) && menuItemKey !== "/") ||
      pathname === menuItemKey ||
      `${pathname}${search}` === menuItemKey
  );

  return selectedKeys;
};
